import { render, staticRenderFns } from "./classical-files-resume.vue?vue&type=template&id=9fc71190"
import script from "./classical-files-resume.vue?vue&type=script&lang=js"
export * from "./classical-files-resume.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports